import {stage} from 'constants/url';
import useDelete from 'components/hooks/useDelete';
import {DeletingOptions} from 'components/grid-dx/types';

function useDeleteStage() {
  const deleteStage = useDelete(stage);
  return (deletingOptions: DeletingOptions) => deleteStage(deletingOptions);
}

export default useDeleteStage;
